var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { str_replace } from '../../../../utils/helper/helper_string';
import { APIData } from '../../../api/APIData';
export class LocationGrade {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get location() {
        return this.parent;
    }
    get gradeQuery() {
        return new APIData({
            route: `/api/personal/${this.location.type}/grade/${this.location.pathURI}`,
            defaultValue: undefined,
        });
    }
    get gradeInfo() {
        return this.gradeQuery.streamedRef;
    }
    get userDisplayGrade() {
        if (!this.gradeInfo)
            return '';
        return str_replace('.', ',', this.gradeInfo.user_grade);
    }
    get userPlace() {
        if (!this.gradeInfo)
            return 100;
        return this.gradeInfo.user_place;
    }
    get gradeTagColor() {
        if (this.userPlace >= 80)
            return 'red';
        if (this.userPlace > 50)
            return 'orange';
        return 'green';
    }
    get gradeColor() {
        if (this.userPlace >= 80)
            return '#9d2020';
        if (this.userPlace > 50)
            return '#8a6d3b';
        return '#5f7927';
    }
    get numQuestions() {
        if (!this.gradeInfo)
            return 0;
        return this.gradeInfo.questions;
    }
}
__decorate([
    memoize
], LocationGrade.prototype, "gradeQuery", null);
